import React, { useEffect, useState, Component, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Button, Paper, Switch, TextField } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { makeStyles } from '@material-ui/core/styles';
import './styles.css';
import PreviewImage from '../../assets/previewImage.png';
import Tooltip from '@material-ui/core/Tooltip';
import PreviewModal from '../../components/modal/previewModal';
import deleteImage from '../../assets/deleteImage.png';
import { CommonConfig } from '../../config/common-config';
import * as Yup from 'yup';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

const useStyles = makeStyles({
    fileView: {
        marginRight: '8px',
        width: '188px !important',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'inline-block',
        overflow: 'hidden',
        marginBottom: '-6px',
    },
});
export default function Card(props) {
    const classes = useStyles();
    const { saveFile } = props;
    const inputFile = useRef(null);
    const [visible, setVisible] = React.useState(false);
    const [downloadFile, setDownloadFile] = useState('');
    const [files, setFiles] = useState(props.data.attachmentsByCoreteam);
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const [handleOpenNew, setHandleOpenNew] = useState(false);
    const [clearDataNew, setClearDataNew] = useState('');
    const [isfileInvalidNew, setIsfileInvalidNew] = useState('');
    const [selectedFileDataNew, setSelectedFileDataNew] = useState(null);
    const [filenameNew, setFilenameNew] = useState('');
    const [uploadSuccessfullyNew, setUploadSuccessfullyNew] = useState('');
    const [isDisableNew, setIsDisableNew] = useState(true);
    const [attachedFileNew, setAttachedFileNew] = useState('');
    const [eventList, setEventList] = useState();
    // let eventList;

    const onButtonClick = () => {
        inputFile.current.click();
    };

    const handleModalClose = () => {
        setVisible(false);
    };

    const handlePreviewModal = (file) => {
        setDownloadFile(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        setTimeout(() => {
            setVisible(true);
        }, 1000);
    };

    const validationSchema = Yup.object().shape({});

    useEffect(() => {
        setFiles(props.data.attachmentsByCoreteam);
        console.log('propsValue', props);
    }, [props, files]);

    const handleRemoveClick = (index, id) => {
        const list = [...files];
        setFiles(list);
    };

    const handleCloseNew = () => {
        setHandleOpenNew(false);
        setIsfileInvalidNew('');
        setUploadSuccessfullyNew('');
    };
    const handleClickNew = () => {
        //console.log('aaaa')
        setHandleOpenNew(true);
        setClearDataNew('');
        setFilenameNew('');
        setIsDisableNew(true);
    };
    const isFileUploadNew = (event, selectorFiles) => {
        setEventList(selectorFiles);
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilenameNew(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidNew('');
                setIsDisableNew(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalidNew('Please select the file size less than 10MB');
                    setIsDisableNew(true);
                } else {
                    setSelectedFileDataNew(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidNew('Please select valid file format i.e pdf');
                setIsDisableNew(true);
            }
        }
        console.log('selectorFiles', eventList);
    };

    return (
        <Paper className="da-card-width">
            <div className="da-icon-container" suppressContentEditableWarning={true}>
                <Switch
                    className="da-switch"
                    color="primary"
                    checked={props.data.toggle}
                    onChange={() => props.toggle(props.data.questionId)}
                    disabled={usertype === 'Other employee users'}
                ></Switch>
                {props.data.editable ? (
                    <span className="da-icon" onClick={() => props.deleteCard(props.data.questionId)}>
                        <FontAwesomeIcon icon={faTrash} />
                    </span>
                ) : (
                    ''
                )}
            </div>
            <div className="da-container" suppressContentEditableWarning={true}>
                <TextField
                    className="da-heading"
                    disabled={usertype === 'EM' ? (props.data.toggle ? '' : 'disabled') : usertype === 'Other employee users'}
                    value={props.data.questionText}
                    contentEditable={props.data.editable}
                    onChange={(event) => props.setTitle(event, props.data.questionId)}
                    InputProps={{
                        disableUnderline: true,
                    }}
                    placeholder={'Enter your question'}
                />
                <TextField
                    value={props.data.remarkByCoreteam}
                    disabled={usertype === 'EM' ? (props.data.toggle ? '' : 'disabled') : usertype === 'Other employee users'}
                    onChange={(event) => props.setRemarks(event, props.data.questionId)}
                    placeholder={'Enter Your Remarks'}
                />
                {props.data.toggle ? <div style={{ fontSize: 'x-small' }}>Please add an attachment</div> : null}
            </div>
            <div>
                <Button
                    variant="outlined"
                    className="btn-style w100"
                    color="primary"
                    disabled={usertype === 'EM' ? (props.data.toggle ? '' : 'disabled') : usertype === 'Other employee users'}
                    onClick={handleClickNew}
                >
                    Add Attachments
                    {/* <input
            type="file"
            ref={inputFile}
            style={{ display: 'none' }}
            multiple
            name="images"
            onChange={(event) => saveFile(props.data.questionId, event)}
          /> */}
                    {props.data.toggle ? <span style={{ color: '#ff0a047a' }}>*</span> : null}
                </Button>
                <Dialog
                    onClose={handleCloseNew}
                    PaperProps={{
                        className: 'QandADailogBox',
                        style: { padding: '20px' },
                    }}
                    aria-labelledby="form-dialog-title"
                    open={handleOpenNew}
                    clear={clearDataNew}
                >
                    <DialogTitle id="form-dialog-title">Upload File</DialogTitle>
                    <DialogContent style={{ textAlign: 'center' }}>
                        <Button className="btnOrange" variant="outlined" component="label" color="default">
                            <i className="btnIcon">
                                <FontAwesomeIcon icon={faPlus} />
                            </i>{' '}
                            Add File
                            <input
                                onChange={(e) => isFileUploadNew(e, e.target.files)}
                                type="file"
                                style={{ display: 'none' }}
                                accept=".jpeg,.png,.csv,.zip,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                            />
                        </Button>
                        {filenameNew ? (
                            <p className="fileName">
                                {filenameNew.substring(0, 15)}
                                {filenameNew.length > 15 ? '...' : ''}
                            </p>
                        ) : null}
                        {filenameNew ? (
                            isfileInvalidNew && isfileInvalidNew.length > 0 ? (
                                <p className="noteCss">Note: {isfileInvalidNew}</p>
                            ) : (
                                ''
                            )
                        ) : null}
                        {/* <p className="fileName">{filenameNew}</p> */}
                    </DialogContent>
                    <p className="fileNameGreen">{uploadSuccessfullyNew}</p>
                    <DialogActions className="paddingBtm txtCenter">
                        <Button
                            className={isDisableNew ? 'disableBtn' : 'btnBluepop'}
                            onClick={() => {
                                setHandleOpenNew(false);
                                saveFile(props.data.questionId, eventList);
                            }}
                            variant="contained"
                            disabled={isDisableNew}
                            component="label"
                            color="default"
                        >
                            Upload
                        </Button>
                        <Button
                            className="btnBluepop"
                            disabled={uploadSuccessfullyNew.length}
                            onClick={() => setHandleOpenNew(false)}
                            variant="contained"
                            component="label"
                            color="default"
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>

                {files.map((ele, i) => {
                    return (
                        <span style={{ paddingTop: '12px', display: 'flex' }}>
                            {ele ? (
                                <span className={classes.fileView}>{ele.substring(ele.lastIndexOf('/') + 1).substring(0, 15) + '...'}</span>
                            ) : null}
                            <span onClick={() => handlePreviewModal(ele)}>
                                <Tooltip title="Preview">
                                    <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                </Tooltip>
                            </span>
                            <span
                                onClick={() => {
                                    props.handleRemoveClick(i, props.data.questionId);
                                    handleRemoveClick(i, props.data.questionId);
                                }}
                            >
                                <Tooltip title="Delete">
                                    <img src={deleteImage} alt="deleteImage" className="closeImg" />
                                </Tooltip>
                            </span>
                        </span>
                    );
                })}
            </div>
            <PreviewModal fileSource={downloadFile} visibleClose={visible} handleModalClose={handleModalClose} />
        </Paper>
    );
}
